module.exports = __webpack_public_path__ + "img/001-location.bed680e5.svg";